import { SubmissionError } from "redux-form";
import fetch from "../../../core/fetch";
import showToaster from "../../../helpers/showToaster";
import messages from "../../../locale/messages";

import {
  inputTextLimit,
  inputDescLimit,
  containsMalicious,
  containsMaliciousForEditor,
} from "../../../helpers/textRestriction";

import { setSiteSettings } from "../../../actions/siteSettings";

async function submit(values, dispatch) {
  // Basic required check
  if (!values?.ogImage) {
    showToaster({ messageId: "ogImageError", toasterType: "error" });
    throw new SubmissionError({ _error: messages.ogImageError });
  }

  // XSS and length validation
  const textFields = [
    "siteName",
    "siteTitle",
    "metaDescription",
    "metaKeyword",
    "facebookLink",
    "twitterLink",
    "instagramLink",
    "playStoreUrl",
    "appStoreUrl",
    "email",
    "phoneNumber",
    "address",
    "androidVersion",
    "iosVersion",
    "listingApproval",
    "appForceUpdate",
    "ogImage",
  ];

  for (const field of textFields) {
    const value = values[field];
    if (value) {
      if (containsMalicious(value)) {
        showToaster({ messageId: "invalidInput", toasterType: "error" });
        throw new SubmissionError({
          _error: `${field}: ${messages.invalidInput}`,
        });
      }
      if (value.length > inputTextLimit) {
        showToaster({ messageId: "inputTooLong", toasterType: "error" });
        throw new SubmissionError({
          _error: `${field}: ${messages.inputTooLong}`,
        });
      }
    }
  }

  if (
    values.metaDescription &&
    containsMaliciousForEditor(values.metaDescription)
  ) {
    showToaster({ messageId: "invalidInput", toasterType: "error" });
    throw new SubmissionError({
      _error: `metaDescription: ${messages.invalidInput}`,
    });
  }

  // Convert boolean fields
  // values.appAvailableStatus = Boolean(Number(values.appAvailableStatus));

  const query = `
  query (
    $siteName: String,
    $siteTitle: String,
    $metaDescription: String,
    $metaKeyword: String,
    $logo: String,
    $facebookLink: String,
    $twitterLink: String,
    $instagramLink: String,
    $homePageType: Int,
    $phoneNumberStatus: Int,
    $homeLogo: String,
    $emailLogo: String,
    $appAvailableStatus: String,
    $playStoreUrl: String,
    $appStoreUrl: String,
    $email: String,
    $phoneNumber: String,
    $address: String,
    $listingApproval: String,
    $appForceUpdate: String,
    $androidVersion: String,
    $iosVersion: String,
    $ogImage: String
  ) {
    updateSiteSettings (
      siteName: $siteName,
      siteTitle: $siteTitle,
      metaDescription: $metaDescription,
      metaKeyword: $metaKeyword,
      logo: $logo,
      facebookLink: $facebookLink,
      twitterLink: $twitterLink,
      instagramLink: $instagramLink,
      homePageType: $homePageType,
      phoneNumberStatus: $phoneNumberStatus,
      homeLogo: $homeLogo,
      emailLogo: $emailLogo,
      appAvailableStatus: $appAvailableStatus,
      playStoreUrl: $playStoreUrl,
      appStoreUrl: $appStoreUrl,
      email: $email,
      phoneNumber: $phoneNumber,
      address: $address,
      listingApproval: $listingApproval,
      appForceUpdate: $appForceUpdate,
      androidVersion: $androidVersion,
      iosVersion: $iosVersion,
      ogImage: $ogImage
    ) {
      status
    }
  }
  `;

  const resp = await fetch("/graphql", {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      query,
      variables: {...values, homePageType: Number(values.homePageType), phoneNumberStatus: Number(values.phoneNumberStatus)},
    }),
    credentials: "include",
  });

  const { data } = await resp.json();

  if (data?.updateSiteSettings?.status === 200) {
    showToaster({ messageId: "updateSiteSettings", toasterType: "success" });
    dispatch(setSiteSettings());
  } else {
    showToaster({ messageId: "updateSettingsError", toasterType: "error" });
    throw new SubmissionError({ _error: messages.updateSettingsError });
  }
}

export default submit;
